import React, {
    Dispatch,
    FC,
    Fragment,
    ReactNode,
    SetStateAction
  } from "react";
  import CloseIcon from "@mui/icons-material/Close";
  import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
  import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
  import { Box, IconButton } from "@mui/material";
  import "animate.css";
  type CustomAccordionProps = {
    children: ReactNode;
    title: string;
    className?: string;
    isExpanded?: boolean;
    setExpanded?: Dispatch<SetStateAction<boolean>>;
    noArrow?: boolean;
    secondary?: boolean;
    ternary?: boolean;
    primary?: boolean;
    closeAction?: (args?: any) => void;
    purpleHeader?:boolean;
  };
  const CustomAccordion: FC<CustomAccordionProps> = ({
    children,
    title,
    className,
    isExpanded = true,
    setExpanded,
    noArrow,
    secondary,
    ternary,
    primary,
    purpleHeader,
    closeAction
  }): JSX.Element => {
    return (
      <div className={`w-full h-auto ${className}`}>
        {isExpanded}
        <div
          className={`w-full py-1animate__bounceInUp animate__animated  px-1   py-1  text-white lg:px-4 rounded-t-lg text-lg cursor-pointer  relative ${
            secondary
              ? `bg-pink-400`
              : ternary
              ? `bg-emerald-400`
              : primary
              ? `bg-amber-400`
              :purpleHeader?`bg-purple-300`
              : ` bg-[#2563eb]`
          } flex items-center justify-between  font-semibold`}
          onClick={() => setExpanded?.((prev) => !prev)}
        >
          {title}
          {!noArrow ? (
            <Fragment>
              {!isExpanded ? (
                <KeyboardArrowDownIcon sx={{ fontSize: "30px" }} />
              ) : (
                <KeyboardArrowUpIcon sx={{ fontSize: "30px" }} />
              )}
            </Fragment>
          ) : (
            <></>
          )}
          {!!closeAction ? (
            <IconButton onClick={()=>closeAction?.()}>
              <CloseIcon sx={{color:"#fff"}} />
            </IconButton>
          ) : (
            <></>
          )}
  
  {/*<div className="screen__background">
  
              <span className="screen__background__shape screen__background__shape1"></span>
          </div>		*/}
  
        </div>
        <Box
          // sx={[
          //   { zIndex: 888, transition: "all 2s linear 2s" },
          //   isExpanded || isExpanded === undefined
          //     ? { height: "auto" }
          //     : isExpanded === false
          //     ? { height: "0px" }
          //     : { height: "auto" },
          // ]}
          sx={
            
            isExpanded
              ? { height: "auto", zIndex: 888, transition: "all 2s linear 2s" }
              : {
                  height: "0px",
                  overflow: "auto",
                  
                  zIndex: 888,
                  transition: "all 2s linear 2s"
                }
          }
        >
          {children}
        </Box>
      </div>
    );
  };
  
  export default CustomAccordion;
  